import { useLocalStorage } from 'react-use';

import { useShouldPromptUserToActivateInvoiceFeature } from 'modules/invoices/hooks/useShouldPromptUserToActivateInvoiceFeature';

const sessionStoragePrefix = 'invoice-feature-';

export const useInvoiceFeatureNavigationItem = (): {
  showPromotion: boolean;
  onHide: () => void;
} => {
  const shouldPromptUser = useShouldPromptUserToActivateInvoiceFeature();
  const [promoteFeature, setPromoteFeature] = useLocalStorage(
    `${sessionStoragePrefix}promote-feature`,
    shouldPromptUser,
  );

  const onHide = () => {
    setPromoteFeature(false);
  };

  return {
    showPromotion: shouldPromptUser && (promoteFeature ?? true),
    onHide,
  };
};
